import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function DirectorWelcome({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <blockquote className="mt-6 text-xl italic text-ink/80 leading-relaxed border-l-4 border-accent pl-6">
            "<EditableText value={data.quote} onChange={(t) => update({ quote: t })} as="span" multiline />"
          </blockquote>
          <p className="mt-6 text-ink/70 leading-relaxed">
            <EditableText value={data.body} onChange={(t) => update({ body: t })} as="span" multiline />
          </p>
          <EditableText value={data.signature} onChange={(t) => update({ signature: t })} as="div" className="mt-6 font-display text-2xl text-olive-deep" />
        </Reveal>
        <Reveal delay={0.1}>
          <EditableImage
            src={data.image?.src}
            alt={data.image?.alt || 'Director'}
            onChange={(src, alt) => update({ image: { src, alt } })}
            className="rounded-3xl shadow-soft h-[520px] w-full object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
}

export default DirectorWelcome;
